// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ApplicationErrorBoundary from './components/ApplicationErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <React.StrictMode>
    <ApplicationErrorBoundary>
      <App />  {/* This calls your App.jsx */}
    </ApplicationErrorBoundary>
  </React.StrictMode>
);
